import React from "react"
import { Input } from "antd"
import { SearchProps } from "antd/lib/input"
import { useDebounceFn } from "ahooks"
import { searchDebounce } from "@/utils/constants"

const { Search } = Input

type PHSearchInput = {
  key?: string
} & SearchProps

export const PHSearchInput = ({ phSearchInputProps }: { phSearchInputProps: PHSearchInput }) => {
  const { onSearch } = phSearchInputProps

  const { run: handleSearchDebounceFn } = useDebounceFn(onSearch, searchDebounce)

  return <Search {...phSearchInputProps} onSearch={handleSearchDebounceFn} />
}
